import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import highlandsLogo from '../assets/highlands_logo.jpg';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={handleLinkClick}>
          <img src={highlandsLogo} alt="Highlands Sports Bar & Grill" />
        </Link>
        
        <button 
          className={`mobile-menu-button ${isMenuOpen ? 'active' : ''}`} 
          onClick={toggleMenu} 
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/" onClick={handleLinkClick} className={location.pathname === '/' ? 'active' : ''}>Home</Link>
          <Link to="/menu" onClick={handleLinkClick} className={location.pathname === '/menu' ? 'active' : ''}>Menu</Link>
          <Link to="/our-story" onClick={handleLinkClick} className={location.pathname === '/our-story' ? 'active' : ''}>Our Story</Link>
          <Link to="/reservations" onClick={handleLinkClick} className={location.pathname === '/reservations' ? 'active' : ''}>Reservations</Link>
          <Link to="/catering" onClick={handleLinkClick} className={location.pathname === '/catering' ? 'active' : ''}>Catering</Link>
          <Link to="/private-events" onClick={handleLinkClick} className={location.pathname === '/private-events' ? 'active' : ''}>Private Events</Link>
          <Link to="/gift-cards" onClick={handleLinkClick} className={location.pathname === '/gift-cards' ? 'active' : ''}>Gift Cards</Link>
          <Link to="/contact-us" onClick={handleLinkClick} className={location.pathname === '/contact-us' ? 'active' : ''}>Contact Us</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 